module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921105651_T.a7a814c2.jpg";